import * as React from "react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import {
  resolveWorkspaceEntityLink,
  type WorkspaceNodeType,
} from "../../../types/workspace";
import { workspaceCanvasPath } from "./workspaceRoutes";

/** Primary entity / workspace name titles — Strategies / Simulator / hub cards. */
export const WORKSPACE_HUB_ENTITY_TITLE_CLASS =
  "truncate font-[family-name:var(--font-primary)] !text-sm font-medium leading-5 text-[color:var(--brand-tropical-surf)] dark:text-white";

export function formatWorkspaceHubDate(value: unknown): string {
  if (typeof value !== "string" || !value.trim()) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function WorkspaceHubLinkCell({
  row,
  nodeType,
  entityId,
  className,
}: {
  row: { workspace_id?: string | null; workspace_name?: string | null };
  nodeType: WorkspaceNodeType;
  entityId: string;
  className?: string;
}): React.ReactElement {
  const { workspaceId, workspaceName } = resolveWorkspaceEntityLink(row);
  const entity = entityId.trim();

  if (!workspaceId || !workspaceName || !entity) {
    return (
      <span
        data-workspace-hub-link-empty=""
        className={cn(
          "font-[family-name:var(--font-primary)] text-sm text-gray-500 dark:text-sidebar-foreground",
          className
        )}
      >
        —
      </span>
    );
  }

  return (
    <Link
      to={workspaceCanvasPath(workspaceId, {
        node: { type: nodeType, entityId: entity },
      })}
      data-workspace-hub-link=""
      data-workspace-hub-link-node={`${nodeType}/${entity}`}
      className={cn(WORKSPACE_HUB_ENTITY_TITLE_CLASS, className)}
      title={`Open in workspace: ${workspaceName}`}
    >
      {workspaceName}
    </Link>
  );
}
